export default __webpack_public_path__ + "static/media/remove-portfolio-minus-icon.19f51908.svg";